import { render, staticRenderFns } from "./ProfileFriends.vue?vue&type=template&id=9458d56c&scoped=true&lang=pug&"
import script from "./ProfileFriends.vue?vue&type=script&lang=js&"
export * from "./ProfileFriends.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFriends.vue?vue&type=style&index=0&id=9458d56c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9458d56c",
  null
  
)

export default component.exports